import { isRoute } from "@medoma/models/routes";
import type { IShiftWithContents } from "@medoma/models/shiftWithContents";

export const findFirstVisitForPatient = ({
  shifts,
  patientId,
}: {
  shifts: IShiftWithContents[];
  patientId: string;
}) =>
  shifts
    .flatMap(({ shift, items }) =>
      items.filter(isRoute).flatMap((route) =>
        route.visits.map((visit) => ({
          visit,
          routeId: route.id,
          shiftId: shift.id,
        })),
      ),
    )
    .find(({ visit }) => visit.patient.id === patientId);
